const { getDetailRequest } = require("./axiosRequest");

const url = `${process.env.REACT_APP_SERVER_URI}/api/v1/pulmonary-function`;

export const getPulmonaryFunc = (param) => getDetailRequest(url, param);
